import { useEffect, useState } from "react";
import { getSudokuId } from "../utils";
import ApiProvider from "../providers/ApiProvider";
import { checkFilled, checkPuzzle, showCellState } from "../helpers";
import { CELL_TYPE } from "../defaults";
const useSudoku = () => {
    const sudokuElement = document.querySelector('.js-sudoku');
    const [id, setId] = useState(0);
    const [puzzle, setPuzzle] = useState([]);
    const [solution, setSolution] = useState([]);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSolved, setIsSolved] = useState(false);
    const [instructions, setInstructions] = useState("");
    const [isFilled, setIsFilled] = useState(false);
    useEffect(() => {
        if (sudokuElement) {
            const id = getSudokuId(sudokuElement);
            setId(id);
            const setSudokuData = async () => {
                const data = await ApiProvider.getSudokuData(id);
                const { puzzle, solution, images, instructions } = data;
                if (puzzle) {
                    let parsedPuzzle = puzzle.map((row) => {
                        return row.map((cell) => {
                            return {
                                type: cell !== 0 ? CELL_TYPE.SET : CELL_TYPE.DEFAULT,
                                valid: true,
                                value: cell
                            };
                        });
                    });
                    setPuzzle(parsedPuzzle);
                }
                if (solution) {
                    setSolution(solution);
                }
                if (images) {
                    setImages(images);
                }
                if (instructions) {
                    setInstructions(instructions);
                }
                setLoading(false);
            };
            setSudokuData();
        }
    }, []);
    const checkSudoku = () => {
        let newPuzzle = showCellState(puzzle, solution);
        if (newPuzzle) {
            setPuzzle(newPuzzle);
        }
        if (checkPuzzle(puzzle, solution)) {
            setIsSolved(true);
            return true;
        }
        return false;
    };
    useEffect(() => {
        if (checkFilled(puzzle)) {
            setIsFilled(true);
        }
        else {
            setIsFilled(false);
        }
    }, [puzzle]);
    return {
        id,
        puzzle, setPuzzle,
        solution,
        images,
        loading, setLoading,
        isSolved, setIsSolved,
        instructions,
        checkSudoku,
        isFilled, setIsFilled
    };
};
export default useSudoku;
